module.exports = __webpack_public_path__ + "assets/img/time_icon.b295ccfd.svg";